module.exports = __webpack_public_path__ + "static/media/icone_contact.01bba11e.svg";